import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect, useRef, useState } from "react";

function PlaceAutocomplete({ onChange, value, error, onSetValue, touched }) {
  const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
  const inputRef = useRef(null);
  const places = useMapsLibrary("places", "geocode");

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options = {
      fields: ["geometry", "name", "formatted_address"],
      //types: ["(regions)"],
      componentRestrictions: { country: "it" },
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener("place_changed", () => {
      const { geometry, name, formatted_address } =
        placeAutocomplete.getPlace();
      console.log("Place changed:", geometry, name, formatted_address);
      const viewport = geometry?.viewport;

      let bounds = null;
      if (viewport) {
        const sw = viewport.getSouthWest();
        const ne = viewport.getNorthEast();
        bounds = {
          sw: { lat: sw.lat(), lng: sw.lng() },
          ne: { lat: ne.lat(), lng: ne.lng() },
          nw: { lat: ne.lat(), lng: sw.lng() },
          se: { lat: sw.lat(), lng: ne.lng() },
        };
      }

      onSetValue((prev) => ({
        ...prev,
        zone: formatted_address,
        bounds,
        center: {
          lat: geometry.location.lat(),
          lng: geometry.location.lng(),
        },
      }));
    });
  }, [placeAutocomplete]);
  return (
    <div className="autocomplete-container">
      <input
        type="text"
        name="zone"
        placeholder="Cerca per città,provincia, zona..."
        ref={inputRef}
        className={"uk-input " + (error && touched ? "uk-form-danger" : "")}
        style={{ height: "45px !important" }}
        onChange={onChange}
        value={value}
      />

      {error && touched && (
        <div className="uk-text-danger uk-margin-small-top">{error}</div>
      )}
    </div>
  );
}

export default PlaceAutocomplete;
